import React, { useDebugValue } from "react";
import MostTrendingStore from "./MostTrendingStore";
import Scrollslider from "./Scrollslider";
import Home3slider from "./home3slider"
import Recommended from "./Recommended";
import NewlyAddedstore from "./NewlyAddedStore"
import { useDispatch } from "react-redux";

function Index({ history, match }) {
  return (
    <>
      <Home3slider/>
       <Scrollslider />
      <MostTrendingStore />
       <Recommended/>
       <NewlyAddedstore/>
    </>
  );
}

export default Index;
